export { default } from './IntersectionObserver';
export { parseRootMargin } from './utils';
export { default as Config } from './config';